<template>
    <app-layout>
        <template #header>
            <div class="relative flex justify-between items-center">
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    <i class="fas fa-coins"/>
                    Criptoativos
                </h2>
                <balance :short="true"/>
            </div>
        </template>
        <div class="py-12">
            <flash :timeout="3000"/>
            <div class="max-w-7xl mx-auto px-6 lg:px-8">
                <menu-cripto/>
                <balance-cripto class="mt-6"/>
                <div class="flex justify-between mt-8">
                    <h2 class="text-black text-opacity-70 text-xl font-bold">
                        Depósito de criptomoedas
                    </h2>
                    <primary-button @click.native="showModalDeposit = true">
                        <i class="fas fa-plus mr-2"/>Novo depósito
                    </primary-button>
                </div>
                <div
                    class="relative rounded-md bg-white px-6 py-5 shadow-card mt-5"
                >
                    <div class="flex justify-between items-center">
                        <h3
                            class="text-black text-opacity-70 text-xl font-bold"
                        >
                            Transações de depósito
                        </h3>
                        <date-filter
                            class="mb-3"
                            :dateTimer="false"
                            :isTodayYesterdayWeekMonth="true"
                            :showRangeDate="false"
                            :buttons="buttonsFilter"
                            :filter="$page.props.queryString.interval"
                        />
                    </div>

                    <div
                        v-show="loaderList"
                        class="z-50 flex justify-center items-center absolute top-0 left-0 w-full h-full bg-gray-400 bg-opacity-20"
                    >
                        <i class="fas fa-spinner animate-spin text-3xl"></i>
                    </div>
                    <inertia-table
                        :enableSearch="false"
                        :enable-page-size="true"
                        :columns="columns"
                        :has-icon="false"
                        :data="deposits"
                        :filters="filters"
                        :params="params"
                        @item-selected="() => null"
                    >
                        <template slot="hash" slot-scope="{ item }">
                            <a :href="getDepositLink(item)" class="underline" target="_blank">
                                {{ item.transfer_hash }}
                            </a>
                        </template>
                        <template slot="status" slot-scope="{ item }">
                            <span
                                class="rounded-full py-1 px-2 text-white font-semibold"
                                :class="getStatus(item.status)?.bg"
                            >
                                {{ getStatus(item.status)?.text }}
                            </span>
                        </template>
                        <template slot="currency" slot-scope="{ item }">
                            <span class="text-sm uppercase">{{ item.coin }}</span>
                        </template>
                        <template slot="network" slot-scope="{ item }">
                            <span class="text-sm uppercase">{{ item.source_wallet.network }}</span>
                        </template>
                        <template slot="created" slot-scope="{ item }">
                            <span class="text-sm">{{
                                item.created | smallDateTime
                            }}</span>
                        </template>
                        <template slot="quantity" slot-scope="{ item }">
                            <span class="text-sm uppercase">
                                {{ cryptoAmountFormat(item.crypto_amount, item.source_wallet.currency) }}
                            </span>
                        </template>
                        <template slot="action" slot-scope="{ item }">
                            <div
                                class="rounded-full cursor-pointer bg-white border text-gray-900 h-10 w-10 flex justify-center items-center text-center"
                                @click="
                                    (selectedDeposit = item),
                                        (showReceipt = true)
                                "
                            >
                                <i class="fas fa-receipt"/>
                            </div>
                        </template>
                    </inertia-table>
                </div>
            </div>
        </div>

        <jet-confirmation-modal
            :show="showModalDeposit"
            :animation="'top'"
            :scroll="false"
            :position-modal="'center'"
            @close="showModalDeposit = false"
        >
            <template #title>
                <div class="w-full">
                    <div class="text-black text-opacity-70 font-bold text-xl">
                        Novo depósito
                    </div>
                    <hr class="mt-1 w-full"/>
                </div>
            </template>
            <template #content>
                <div class="mt-2">
                    <p class="text-sm text-gray-600">
                        Selecione uma moeda e uma rede para criarmos um
                        endereçamento de depósito. Após a confirmação enviaremos
                        o QR para realização do depósito.
                    </p>
                    <div class="mt-4">
                        <jet-label :value="'Moeda'"/>
                        <auto-complete
                            v-if="showModalDeposit"
                            :auto-load="true"
                            :endpoint="'cripto/new-currencies'"
                            v-model="form.selectedCoin"
                        />
                    </div>
                    <div class="my-4">
                        <jet-label :value="'Rede'"/>
                        <auto-complete
                            :disabled="true"
                            :value="form.selectedCoin?.network?.toUpperCase()"
                        />
                    </div>
                </div>
            </template>
            <template #footer>
                <div class="flex justify-between">
                    <secondary-button @click.native="showModalDeposit = false">
                        Cancelar
                    </secondary-button>
                    <primary-button
                        :isDisabled="!form.selectedCoin || form.processing"
                        @click.native="newDepositAddress"
                    >
                        <i
                            v-show="form.processing"
                            :class="{
                                'fas fa-spinner animate-spin mr-2':
                                    form.processing
                            }"
                        />
                        Confirmar
                    </primary-button>
                </div>
            </template>
        </jet-confirmation-modal>

        <jet-confirmation-modal
            :show="showModalQrCode"
            :scroll="false"
            :position-modal="'center'"
            @close="showModalQrCode = false"
        >
            <template #title>
                <div class="w-full">
                    <div class="text-black text-opacity-70 font-bold text-xl">
                        Endereço de depósito
                    </div>
                    <hr class="mt-1 w-full"/>
                </div>
            </template>
            <template #content>
                <div class="mt-2">
                    <p class="text-sm text-gray-600">
                        Endereçamento de depósito foi gerado com sucesso!
                        <br/><br/>
                        Escaneie o QR ou copie o endereço abaixo e entre na sua
                        plataforma para realizar o depósito.
                    </p>
                    <div id="qr-code-address" class="mt-4 flex justify-center">
                        <i v-if="!qrCodeAddress" class="fas fa-spinner animate-spin text-3xl" />
                    </div>
                    <div
                        class="my-4 flex justify-center bg-gray-200 py-3 rounded-md"
                    >
                        <copy-value :value="address?.wallet_address" tooltip="Copiar hash"/>
                    </div>
                </div>
            </template>
            <template #footer>
                <div class="flex justify-end">
                    <primary-button @click.native="showModalQrCode = false"
                        >Confirmar</primary-button
                    >
                </div>
            </template>
        </jet-confirmation-modal>

        <jet-dialog-modal
            :show="showReceipt"
            maxWidth="md"
            position="fixed"
            id="transfer-receipt"
        >
            <template #title>
                Comprovante de depósito
            </template>
            <template #content>
                <div class="border-t border-gray-300 text-center">
                    <div class="flex justify-center mt-3 border-b pb-2">
                        <img
                            :src="$page.props.white_label.data.logo_white"
                            alt=""
                        />
                    </div>

                    <div class="pt-3 pb-5 text-lg text-black font-semibold">
                        Detalhes do depósito
                    </div>
                </div>
                <div class="px-4">
                    <div class="flex justify-between mb-2 mt-2">
                        <div class="text-gray-500">
                            Status
                        </div>
                        <div>
                            {{ getStatus(selectedDeposit?.status).text }}
                        </div>
                    </div>
                    <div class="flex justify-between mb-2">
                        <div class="text-gray-500">
                            Moeda
                        </div>
                        <div class="uppercase">
                            {{ selectedDeposit?.coin ?? '--' }}
                        </div>
                    </div>
                    <div class="flex justify-between mb-2">
                        <div class="text-gray-500">
                            Rede
                        </div>
                        <div class="uppercase">
                            {{ selectedDeposit?.source_wallet?.network ?? '--' }}
                        </div>
                    </div>
                    <div class="flex justify-between mb-2">
                        <div class="text-gray-500">
                            Carteira de depósito
                        </div>
                        <div>
                            {{ selectedDeposit?.source_wallet.name }}
                        </div>
                    </div>
                </div>
                <hr class="w-full mt-4" />
                <div class="pt-3 pb-5 text-center">
                    <div class="text-lg text-black font-semibold">
                        Valor do depósito
                    </div>
                    <div class="text-lg font-bold uppercase">
                        {{ `${formatAmount(selectedDeposit?.crypto_amount)} ${selectedDeposit?.coin}` }}
                    </div>
                </div>
                <div class="flex justify-between mb-2">
                    <div class="text-gray-500">
                        Data
                    </div>
                    <div>
                        {{ selectedDeposit?.created | smallDateTime }}
                    </div>
                </div>
                <div class="pt-5 remove-to-print">
                    <div class="flex items-center justify-end">
                        <RoundedIcon
                            class="w-9 h-9 bg-green-500 text-white mr-4"
                            v-tippy
                            content="Baixar em PNG"
                            :icon="'far fa-file-image'"
                            @click.native="print('png')"
                        />
                        <RoundedIcon
                            class="w-9 h-9 bg-red-600 text-white"
                            v-tippy
                            content="Baixar em PDF"
                            :icon="'fas fa-file-pdf'"
                            @click.native="print('pdf')"
                        />
                    </div>
                </div>
            </template>

            <template #footer>
                <secondary-button
                    class="remove-to-print"
                    @click.native="showReceipt = false"
                >
                    FECHAR
                </secondary-button>
            </template>
        </jet-dialog-modal>
    </app-layout>
</template>

<script type="module">
import Balance from "../../../Helpers/Balance.vue";
import DateFilter from "../../../Helpers/Tables/DateFilter.vue";
import InertiaTable from "../../../Helpers/Tables/InertiaTable.vue";
import PrimaryButton from "../../../Jetstream/PrimaryButton.vue";
import JetLabel from "../../../Jetstream/Label.vue";
import AppLayout from "../../../Layouts/AppLayout.vue";
import JetConfirmationModal from "../../../Jetstream/ConfirmationModal.vue";
import ActionButtons from "../ActionButtons.vue";
import BalanceCripto from "../Balance.vue";
import MenuCripto from "../components/MenuCripto.vue";
import AutoComplete from "../../../Jetstream/AutoComplete.vue";
import SecondaryButton from "../../../Jetstream/SecondaryButton.vue";
import Flash from "../../../Helpers/Flash.vue";
import JetDialogModal from "../../../Jetstream/DialogModal.vue";
import RoundedIcon from "../../Send/components/RoundedIcon.vue";
import CopyValue from "../../../Jetstream/CopyValue.vue";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import numberFormat from "../utils/numberFormat";
import cryptoAmountFormat from "../utils/cryptoAmountFormat";

const getURLDeposit = {
    trx: {
        production: 'https://tronscan.org/#/transaction/',
        development: 'https://shasta.tronscan.org/#/transaction/'
    },
    eth: {
        production: 'https://etherscan.io/tx/',
        development: 'https://goerli.etherscan.io/tx/'
    }
}

export default {
    props: ["deposits", "address"],
    methods: {
        cryptoAmountFormat,
        formatAmount(amount){
            if(!amount) return ''
            return window.Web3?.utils?.fromWei(amount, 'ether')
        },
        getDepositLink(deposit){
            const { transfer_hash, source_wallet } = deposit
            return `${getURLDeposit[source_wallet.network][process.env.NODE_ENV]}${transfer_hash}`
        },
        newDepositAddress() {
            if (this.form.processing || !this.form.selectedCoin) return
            this.form.post("/crypto/deposit", {
                preserveState: true,
                onSuccess: () => {
                    document.querySelector('#qr-code-address img')?.remove()
                    const contentImg = document.querySelector('#qr-code-address')
                    const img = document.createElement('img')
                    img.onload = () => {
                        contentImg.appendChild(img)
                        this.qrCodeAddress = true
                    }
                    img.src = encodeURI(
                        `https://chart.googleapis.com/chart?cht=qr&chs=190x190&chl=${this.address.wallet_address}&chld=L|1`
                    );
                    this.showModalDeposit = false;
                    this.showModalQrCode = true;
                },
                onError: () => {
                    this.form.processing = false;
                }
            });
        },
        print(type) {
            const toggleHiddenButtons = () =>
                document
                    .querySelectorAll(".remove-to-print")
                    .forEach(el => el.classList.toggle("hidden"));

            toggleHiddenButtons();
            html2canvas(document.querySelector("#transfer-receipt"), {
                dpi: 144,
                scale: 1
            }).then(canvas => {
                let imgData = canvas.toDataURL("image/png");
                if (type === "png") {
                    const a = document.createElement("a");
                    a.href = imgData;
                    a.download = "comprovante.png";
                    a.click();
                    return;
                }
                let doc = new jsPDF();
                doc.addImage(imgData, "PNG", 46, 10);
                doc.save(`comprovante.${type}`);
            });
            toggleHiddenButtons();
        },
        getStatus(status) {
            switch (status) {
                case "confirmed":
                    return { text: "Confirmado", bg: "bg-green-500" };
                case "failed":
                    return { text: "Falhou", bg: "bg-red-500" };
                default:
                    return { text: "Rejeitada", bg: "bg-red-500" };
            }
        },
        refreshList() {
            clearInterval(this.timer);
            this.timer = setInterval(async () => {
                this.loaderList = true;
                const { data } = await axios.get(this.route("deposit.index", this.$page.props.queryString));
                this.deposits.list = data?.list;
                this.loaderList = false;
            }, 30000);
        }
    },
    async mounted() {
        this.refreshList();
        const { data } = await axios.get('/json/cripto/new-currencies')
        this.filters[0].options = data.list?.map((coin) => ({
            ...coin,
            id: coin.bitgo_native_coin,
            name: coin.name.toUpperCase()
        })) ?? []
    },
    data() {
        return {
            timer: 0,
            cryptos: [],
            numberFormat,
            loaderList: false,
            showModalDeposit: false,
            selectedDeposit: null,
            showReceipt: false,
            showModalQrCode: false,
            qrCodeAddress: false,
            form: this.$inertia.form({
                selectedCoin: null,
                network: null
            }),
            filters: [
                {
                    text: 'Moeda',
                    key: 'coin',
                    type: 'dropdown',
                    options: []
                },
                {
                    text: 'Rede',
                    key: 'network',
                    type: 'dropdown',
                    options: [
                        { id: 'eth', name: 'ETH' },
                        { id: 'trx', name: 'TRX' },
                    ],
                    colSpan: 2
                },
                {
                    text: 'Status',
                    key: 'status',
                    type: 'dropdown',
                    options: [
                        { id: 'confirmed', name: 'Confimardo' },
                        { id: 'failed', name: 'Falhou' },
                    ],
                    colSpan: 2
                },
                {
                    text: 'Período',
                    key: 'date',
                    type: 'date_interval2',
                    colSpan: 2
                },
            ],
            columns: [
                {text: "Hash de depósito", key: "hash"},
                {text: "Status", key: "status"},
                {text: "Moeda", key: "currency"},
                {text: "Rede", key: "network", sortable: true},
                {text: "Data de execução", key: "created", sortable: true},
                {text: "Quantidade", key: "quantity"},
                {text: "", key: "action"}
            ],
            buttonsFilter: [
                {name: "Hoje", key: "today"},
                {name: "Ontem", key: "yesterday"},
                {name: "Esta semana", key: "week"},
                {name: "Este mês", key: "month"}
            ],
            params: {
                ...this.$page.props.queryString,
                sort: 'created:desc'
            }
        };
    },
    components: {
        ActionButtons,
        AppLayout,
        Balance,
        MenuCripto,
        BalanceCripto,
        PrimaryButton,
        DateFilter,
        InertiaTable,
        JetConfirmationModal,
        JetLabel,
        AutoComplete,
        SecondaryButton,
        Flash,
        JetDialogModal,
        RoundedIcon,
        CopyValue
    }
};
</script>
